module.exports = __webpack_public_path__ + "img/user.cac51d2f.png";